import {createApp} from 'vue';
import ShareProductPage from '../organization-payments/share-product-page';
import ProductLandingPage from '../organization-payments/product-landing-page';
import PaymentSuccess from '../organization-payments/payment-success';
import {createRouter, createWebHashHistory} from 'vue-router';
import Toaster from '@meforma/vue-toaster';

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        // {
        //   path: '/organization/:organization_id/products/:product_id',
        //   name: 'share-product-landing',
        //   component: ProductLandingPage,
        // },
        {
            path: '/payment_success',
            name: 'payment_success',
            component: PaymentSuccess,
        },
    ],
});

const app = createApp(ShareProductPage);

app.use(router);
app.use(Toaster);
document.addEventListener('DOMContentLoaded', () => {
    const appContainer = document.createElement('div');
    document.body.appendChild(appContainer);
    app.mount(appContainer);
});
